var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusnotenote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1964,
    height: 1964,
    viewBox: "0 0 1964 1964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V1963.47H1225.62L1963.47 1225.62V0H0ZM133.117 133.117H1830.36V1031.66H1031.66V1830.36H133.117V133.117ZM1170.48 1830.36H1164.77V1164.77H1830.36V1170.48L1170.48 1830.36Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M765.422 1098.21V765.422H1098.21V632.305H765.422V299.513H632.305V632.305H299.513V765.422H632.305V1098.21H765.422Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusnotenote);
export default __webpack_public_path__ + "static/media/plusnotenote+.55042cd815b2923f8cdce6f120423190.svg";
export { ForwardRef as ReactComponent };